import React from 'react';
import Title from '../../../elements/Title';
import Link from '../../../components/Link';
import Content from '../../../elements/Content';
import Section from '../../../elements/Section';

export default function SharePrice() {
  return (
    <Section>
      <Title>Share Price</Title>
      <Content>
        <Link
          href="https://www.euronext.com/products/equities/BE6252013725-XMLI"
          target="_blank">
          View on Euronext
        </Link>
      </Content>
    </Section>
  );
}
